query LookupDepotSearch(
  $lookupDepot: String!
  $first: Int!
  $isAirport: Boolean
  $isTrain: Boolean
) {
  lookupDepotSearch(
    lookupDepot: $lookupDepot
    isAirport: $isAirport
    isTrain: $isTrain
    first: $first
    orderBy: _SORT_ORDER_ASC
  ) {
    nodes {
      id
      cityArea
      description
      stateRegion
      isTrainDepot
    }
  }
}
